import { report } from '../report';
function checkNoTranquil(node) {
    var _a;
    return ((node instanceof HTMLElement && node.hasAttribute('data-notranquil')) ||
        ((_a = node.parentElement) === null || _a === void 0 ? void 0 : _a.closest('[data-notranquil=true]')) != null);
}
function traverseDOM() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
        var node = walker.currentNode;
        var text = node.nodeValue;
        if (text == null || checkNoTranquil(node)) {
            continue;
        }
        report({
            text: text,
            node: node,
        });
    }
}
function initMutationObserver() {
    try {
        if (typeof MutationObserver === 'undefined') {
            return;
        }
        var mutationObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                var type = mutation.type, addedNodes = mutation.addedNodes, target = mutation.target;
                if (type !== 'childList' ||
                    !addedNodes.length ||
                    checkNoTranquil(target)) {
                    return;
                }
                for (var _i = 0, _a = Array.from(addedNodes); _i < _a.length; _i++) {
                    var addedNode = _a[_i];
                    var iter = document.createNodeIterator(addedNode, NodeFilter.SHOW_TEXT);
                    var textNode = iter.nextNode();
                    while (textNode) {
                        var node = textNode;
                        textNode = iter.nextNode();
                        var text = node.nodeValue;
                        if (text == null || checkNoTranquil(node)) {
                            continue;
                        }
                        report({
                            text: text,
                            node: node,
                        });
                    }
                }
            });
        });
        mutationObserver.observe(document.body, {
            subtree: true,
            childList: true,
        });
    }
    catch (error) {
        // empty
    }
}
export default function start() {
    traverseDOM();
    initMutationObserver();
}
